import fs from 'fs';
import dotenv from 'dotenv';
import mod from 'google-spreadsheet';
import _, { setWith, unset, uniq } from 'lodash';
import chalk from 'chalk';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

dotenv.config();
var GoogleSpreadsheet = mod.GoogleSpreadsheet;
var getWorksheet = function (spreadsheetId, worksheetId, pathToConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var credentialsFile, credentials, doc, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                credentialsFile = fs.readFileSync(pathToConfig, "utf8");
                credentials = JSON.parse(credentialsFile);
                doc = new GoogleSpreadsheet(spreadsheetId);
                return [4 /*yield*/, doc.useServiceAccountAuth(credentials)];
            case 1:
                _a.sent();
                return [4 /*yield*/, doc.loadInfo()];
            case 2:
                _a.sent();
                return [2 /*return*/, doc.sheetsById[worksheetId]];
            case 3:
                e_1 = _a.sent();
                console.error(e_1.message);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
var sortObject = function (object) {
    var sortedObj = {};
    var keys = Object.keys(object);
    keys.sort(function (key1, key2) {
        (key1 = key1.toLowerCase()), (key2 = key2.toLowerCase());
        if (key1 < key2)
            return -1;
        if (key1 > key2)
            return 1;
        return 0;
    });
    for (var index in keys) {
        var key = keys[index];
        if (typeof object[key] === "object" && !(object[key] instanceof Array)) {
            sortedObj[key] = sortObject(object[key]);
        }
        else {
            sortedObj[key] = object[key];
        }
    }
    return sortedObj;
};
/**
 * Remove any nested empty object in the specified object.
 *
 * @param {object} obj - any object
 *
 * @returns {object}
 */
var removeEmptyObjects = function (obj) {
    return _(obj)
        .pickBy(_.isObject)
        .mapValues(removeEmptyObjects)
        .omitBy(_.isEmpty)
        .assign(_.omitBy(obj, _.isObject))
        .value();
};
/**
 * Flattens objects, returning a one-level object.
 *
 * @param obj - any object
 *
 * @returns {object}
 */
var flattenObject = function (obj) {
    var toReturn = {};
    for (var i in obj) {
        if (!obj.hasOwnProperty(i))
            continue;
        if (typeof obj[i] == "object") {
            var flatObject = flattenObject(obj[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x))
                    continue;
                toReturn[i + "." + x] = flatObject[x];
            }
        }
        else {
            toReturn[i] = obj[i];
        }
    }
    return toReturn;
};

var Locales$1;
(function (Locales) {
    Locales["en"] = "EN";
    Locales["fr"] = "FR";
    Locales["es"] = "ES";
    Locales["ca-ES"] = "CA(ES)";
    Locales["it"] = "IT";
    Locales["pt"] = "PT";
    Locales["fr-nc"] = "FR(NC)";
    Locales["es-ic"] = "ES(IC)";
    Locales["es-ad"] = "ES(ANDORRA)";
    Locales["de"] = "DE";
})(Locales$1 || (Locales$1 = {}));
var RowInfos$1;
(function (RowInfos) {
    RowInfos["key"] = "KEY";
    RowInfos["type"] = "1";
})(RowInfos$1 || (RowInfos$1 = {}));
/**
 * Returns translation value according to a given language
 * Fallback to:
 *   - es for ca-ES, es-ic and es-ad
 *   - fr for fr-nc
 *
 * @param {Object} row - contains values for all languages
 * @param {string} key - language key of the value we want to retrieve
 *
 * @returns {string}
 */
var getValue = function (row, key) {
    if (row[key] !== "") {
        return row[key];
    }
    if (key === "FR(NC)" && row["FR"]) {
        return row["FR"];
    }
    if ((key === "ES(IC)" || key === "ES(ANDORRA)") && row["ES"]) {
        return row["ES"];
    }
    return row["EN"];
};
/**
 * Escapes characters such as double quote and carriage returns
 *
 * @param {string} value
 *
 * @returns {string}
 */
var makeSafeValue$1 = function (value) {
    return value
        .replace(/"/g, '\\"')
        .replace(/\r/g, "\\n")
        .replace(/\n/g, "\\n")
        .replace(/\r\n/g, "\\n");
};
/**
 * Write translation value in specified path for all locales
 *
 * @param {string} rootPath - path of the translation files
 * @param {string} cellType - attribute to look at to check the type of the row
 * @param {Object} row
 *
 * @returns {void}
 */
var writeValue = function (rootPath, cellType) { return function (row) {
    Object.entries(Locales$1).map(function (_a) {
        var langKey = _a[0], keyInSheet = _a[1];
        var path = rootPath + "/" + langKey + ".lproj/Localizable.strings";
        var value;
        switch (row[cellType]) {
            case "APP":
                value = "\n // MARK: - App: " + row["KEY"] + " - \n // --------------------------------- \n";
                break;
            case "MODULE":
                value = "\n // MARK: - Module: " + row["KEY"] + " - \n // --------------------------------- \n";
                break;
            case "CATEGORY":
                value = "\n // MARK: - " + row["KEY"] + " \n";
                break;
            case "":
                if (row["KEY"]) {
                    value = getValue(row, keyInSheet);
                    var translationValue = value ? makeSafeValue$1(value) : value;
                    value = "\"" + row["KEY"] + "\" = \"" + translationValue + "\";\n";
                }
                break;
        }
        value && fs.appendFileSync(path, value);
    });
}; };
var generatePosTranslations = function (spreadsheetId, worksheetId, pathToTranslationFiles, pathToConfig) {
    if (pathToTranslationFiles === void 0) { pathToTranslationFiles = "."; }
    if (pathToConfig === void 0) { pathToConfig = './google-credentials.json'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var sheet, cellType, _a, rows;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(spreadsheetId && worksheetId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getWorksheet(spreadsheetId, worksheetId, pathToConfig)];
                case 1:
                    sheet = _b.sent();
                    return [4 /*yield*/, sheet.loadHeaderRow()];
                case 2:
                    _b.sent();
                    cellType = sheet.headerValues[0];
                    return [4 /*yield*/, sheet.getRows()];
                case 3:
                    _a = _b.sent(), rows = _a.slice(1);
                    Object.entries(Locales$1).map(function (_a) {
                        var langKey = _a[0];
                        if (!fs.existsSync(pathToTranslationFiles + "/" + langKey + ".lproj")) {
                            fs.mkdirSync(pathToTranslationFiles + "/" + langKey + ".lproj");
                        }
                        var generatedTime = new Date();
                        var value = "\n/*  AUTO-GENERATED: " + generatedTime.toISOString() + " */\n/*  GOOGLE SHEETS LINK: https://docs.google.com/spreadsheets/d/1xyONg14hA_vkCt6tENScp0I_MPIvscsdgI9ZLO1YkBA/edit#gid=0  */\n\n";
                        fs.writeFileSync(pathToTranslationFiles + "/" + langKey + ".lproj/Localizable.strings", value);
                    });
                    if (!fs.existsSync(pathToTranslationFiles + "/Base.lproj")) {
                        fs.mkdirSync(pathToTranslationFiles + "/Base.lproj");
                    }
                    rows.map(writeValue(pathToTranslationFiles, cellType));
                    fs.copyFileSync(pathToTranslationFiles + "/en.lproj/Localizable.strings", pathToTranslationFiles + "/Base.lproj/Localizable.strings");
                    return [3 /*break*/, 5];
                case 4:
                    console.log("Please provide spreadsheetId and worksheetId values");
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
};

var Locales;
(function (Locales) {
    Locales["ca"] = "CA(ES)";
    Locales["de"] = "DE";
    Locales["en"] = "EN";
    Locales["en-GB"] = "EN(UK)";
    Locales["es"] = "ES";
    Locales["fr"] = "FR";
    Locales["it"] = "IT";
    Locales["pt"] = "PT";
})(Locales || (Locales = {}));
var RowInfos;
(function (RowInfos) {
    RowInfos["Key"] = "KEY";
    RowInfos["Type"] = "CATEGORY";
})(RowInfos || (RowInfos = {}));
/**
 * Escapes carriage returns
 *
 * @param {string} value
 *
 * @returns {string}
 */
var makeSafeValue = function (value) {
    return value
        .replace(/\r/g, "")
        .replace(/\n/g, "")
        .replace(/\r\n/g, "");
};
var gsheetUndefinedValues = [];
/**
 * Should return the correct value to be put in translation file
 *
 * @param row - row to work on
 * @param lang - language to work with
 * @param currentTranslation - current translation available
 */
var getCorrectValue = function (row, lang, currentTranslation) {
    if (row[lang] === "" || row[lang] === undefined) {
        if (row[Locales.en] === "") {
            gsheetUndefinedValues.push(row[RowInfos.Key]);
        }
        return undefined;
    }
    unset(currentTranslation, row[RowInfos.Key]);
    return makeSafeValue(row[lang]);
};
/**
 * Add new rows to the spreadsheet
 *
 * @param rows - rows you want to add, should be in { 'KEY': { 'EN': '', 'FR': '', ... } } format
 */
var addNewRows = function (sheet, rows) {
    var rowsToAdd = Object.keys(rows).map(function (key) {
        var _a;
        return (__assign((_a = {}, _a[RowInfos.Key] = key, _a), rows[key]));
    });
    if (rowsToAdd.length === 0)
        return;
    sheet.addRows(rowsToAdd);
    var logMessage = "\n[" + chalk.blue("NEW KEYS") + "] The following keys have been added to the spreadsheet:\n";
    rowsToAdd.forEach(function (row) {
        logMessage += "\t\u2022 " + row[RowInfos.Key] + " (" + Object.keys(rows[row[RowInfos.Key]]) + ")\n";
        if (row[Locales.en] === undefined) {
            gsheetUndefinedValues.push(row[RowInfos.Key]);
        }
    });
    console.info(logMessage);
};
/**
 * Logs spreadsheet undefined values
 */
var logUndefinedValues = function () {
    if (gsheetUndefinedValues.length === 0)
        return;
    var uniqUndefinedValues = uniq(gsheetUndefinedValues);
    var warningMessage = "\n[" + chalk.yellow("WARNING") + "] The following keys have no english value:\n";
    uniqUndefinedValues.forEach(function (value) {
        warningMessage += "\t\u2022 " + value + "\n";
    });
    console.warn(warningMessage);
};
/**
 * Generates translations for Sonar
 *
 * @param spreadsheetId - id of the spreadsheet you're working on
 * @param worksheetId - id of the worksheet you're working on in the spreadsheet
 * @param pathToTranslationFiles - path in which you want translation to be generated
 * @param pathToConfig - path to google credentials file
 */
var generateSonarTranslations = function (spreadsheetId, worksheetId, pathToTranslationFiles, pathToConfig) {
    if (pathToTranslationFiles === void 0) { pathToTranslationFiles = "."; }
    if (pathToConfig === void 0) { pathToConfig = "./google-credentials.json"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var sheet, _a, rows_1, newRows_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(spreadsheetId && worksheetId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getWorksheet(spreadsheetId, worksheetId, pathToConfig)];
                case 1:
                    sheet = _b.sent();
                    return [4 /*yield*/, sheet.loadHeaderRow()];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, sheet.getRows()];
                case 3:
                    _a = _b.sent(), rows_1 = _a.slice(1);
                    newRows_1 = {};
                    Object.entries(Locales).forEach(function (_a) {
                        var langKey = _a[0], lang = _a[1];
                        var currentTranslation = {};
                        var translation = {};
                        if (fs.existsSync(pathToTranslationFiles + "/" + langKey + "/translations.json")) {
                            var currentTranslationFile = fs.readFileSync(pathToTranslationFiles + "/" + langKey + "/translations.json", "utf8");
                            currentTranslation = JSON.parse(currentTranslationFile);
                        }
                        for (var _i = 0, rows_2 = rows_1; _i < rows_2.length; _i++) {
                            var row = rows_2[_i];
                            var value = getCorrectValue(row, lang, currentTranslation);
                            setWith(translation, row[RowInfos.Key], value, Object);
                        }
                        var flatTranslation = flattenObject(removeEmptyObjects(currentTranslation));
                        Object.keys(flatTranslation).forEach(function (key) {
                            var _a;
                            newRows_1[key] = __assign(__assign({}, newRows_1[key]), (_a = {}, _a[lang] = flatTranslation[key], _a));
                        });
                        fs.writeFileSync(pathToTranslationFiles + "/" + langKey + "/translations.json", JSON.stringify(sortObject(__assign(__assign({}, currentTranslation), translation)), null, 2));
                    });
                    addNewRows(sheet, newRows_1);
                    logUndefinedValues();
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
};

/** Returns the fallback language code
 * examples with availableLanguages = ['fr', 'en', 'en-GB', 'es']:
 * - fr => ["en"]
 * - fr-CA => ["fr", "en"]
 * - es-MX => ["es", "en"]
 * - ja => ["en"]
 * - vtt => ["en"]
 * - en-GB => ['en']
 */
var getFallbackLanguagesCodes = function (_a) {
    var availableLanguages = _a.availableLanguages, _b = _a.defaultFallbackLanguage, defaultFallbackLanguage = _b === void 0 ? "en" : _b, languageCode = _a.languageCode;
    // list of fallback languages, ordered by priority
    var fallbackLanguages = [];
    if ((languageCode === null || languageCode === void 0 ? void 0 : languageCode.length) > 2) {
        // get the 2 lowercase letters before the "-", returning the language without the region code
        var match = languageCode.match("^([a-z]{2})-.*$");
        if ((match === null || match === void 0 ? void 0 : match.length) === 2) {
            var languageWithoutRegionCode = match[1];
            // if the languageWithoutRegionCode is in availableLanguages and it's not {defaultFallbackLanguage}, add it as a first priority in fallbackLanguages
            if (availableLanguages.includes(languageWithoutRegionCode) &&
                languageWithoutRegionCode !== defaultFallbackLanguage) {
                fallbackLanguages.push(languageWithoutRegionCode);
            }
        }
    }
    // finally push {defaultFallbackLanguage} as our last fallbackLanguage
    fallbackLanguages.push(defaultFallbackLanguage);
    return fallbackLanguages;
};

export { generatePosTranslations, generateSonarTranslations, getFallbackLanguagesCodes };
//# sourceMappingURL=index.es5.js.map
